<template>
<v-dialog :fullscreen="$vuetify.breakpoint.mobile"
          :value="value" :style="{ borderRadius: '50px' }"
          scrollable max-width="80%"
          persistent>
  <v-card class="d-flex flex-column">
    <v-card-title class="primary white--text">
      {{getTitle}}
      <v-spacer/>
      <v-btn text elevation="0" color="white" small @click="$emit('input', false)">
        Fechar <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text class="py-4 flex-grow-1" v-if="value">
      <v-form ref="form" @submit.prevent="save" 
        v-model="formValid" lazy-validation>
        <mensagem-form v-model="item"
        :responsaveisSelecionados="responsaveisSelecionados"
        :search-values="searchValues"
        />
      </v-form>

    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="success" @click="$emit('input', false)" :disabled="loading">Cancelar</v-btn>
      <v-btn color="primary" @click="save" :disabled="!formValid || loading">Salvar</v-btn>      
    </v-card-actions>
  </v-card>
  <v-overlay :value="loading" absolute>
    <v-progress-circular
      indeterminate
      color="primary"
      class="ma-4"
    ></v-progress-circular>
  </v-overlay>  
</v-dialog>
</template>

<script>
import MensagemForm from "../forms/MensagemForm";
import {createPorGrupo} from "../../../api/mensagem";
import {ApiError} from "../../../api/core";

export default {
  name: "CreateEditMensagemDialog",
  components: {MensagemForm},
  props: [
      'value',
      'item',
      'responsaveisSelecionados',
      'searchValues'
    ],
  data () {
    return {
      formValid: false,
      loading: false,
    }
  },
  computed: {
    getTitle() {
      return 'Adicionar Mensagem(ns)'
    }
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        this.item.idContatos = this.responsaveisSelecionados.join(',')
        if(this.$refs.form.validate()) {
          await createPorGrupo(this.item);
          this.$emit('input', false);
          this.$emit('onSave');
          this.$toast.success(`Envio da(s) Mensagem(ns) programada(s) com sucesso.`, {
            timeout: 3000
          })
        }
      } catch (err) {
        if(err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível programar o envio da(s) Mensagem(ns).`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>

</style>